import React from "react";

export function Policy() {
    return (
        <>
        <center>
            <div class="right2">
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
           
                <h1 className="text-5xl md:text-5xl font-bold mb-6">Rules and Regulations</h1><hr/>
                <p><strong>Monroe  Fire District #1 operates under State Statue&nbsp;  40A;14 etc. and &nbsp;the Uniform Fire  Code outlined in New <br/>Jersey Administrative Code Title 5, Chapter 70, 71, 72,  73, and 75. Specifically, the Board of Fire Commissioners operates in  accordance 40A; 14 -70etc. </strong></p>
                <p><strong>  Links  to these references can be found at the following websites:</strong></p>
                <ul> 
                <li><strong><a href="http://www.nj.gov/dca/divisions/dfs/codes/">http://www.nj.gov/dca/divisions/dfs/codes/</a>&nbsp;- New Jersey Division of Community  Affairs</strong></li>
                <li><strong><a href="http://www.lexisnexis.com/hottopics/njcode/">http://www.lexisnexis.com/hottopics/njcode/</a>&nbsp;- New Jersey Administrative Code  Research Tool (search engine)</strong></li>
                <li><strong><a href="http://www.state.nj.us/dca/divisions/dlgs/programs/au_docs/40a_14_70.pdf">http://www.state.nj.us/dca/divisions/dlgs/programs/au_docs/40a_14_70.pdf</a></strong></li>
                <li><strong><a href="http://statutes.laws.com/new-jersey/title-40a/section-40a-14">http://statutes.laws.com/new-jersey/title-40a/section-40a-14</a></strong></li>
                
                </ul></div>
        </center>
        </>
    )
}